import { render } from "./ScriptComponent.vue?vue&type=template&id=4e78982e"
import script from "./ScriptComponent.vue?vue&type=script&lang=ts"
export * from "./ScriptComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script